import { useEffect, useState } from 'react';

import { VStack } from '../VStack';
import { KeyboardArrowRight } from '../asset';
import { new__cn } from '../util';
import style from './style';
import type { VListItemProps } from './type';

const VListItem = <
  T extends { id: any; name: string; len?: number; [key: string]: any },
>({
  className,
  itemClassName,
  list,
  title,
  value,
  onChange,
  onItemClick,
  ...rest
}: VListItemProps<T> &
  Omit<React.ComponentPropsWithRef<'div'>, 'onChange'>) => {
  const [innerSelectedItem, setInnerSelectedItem] = useState<Nullish<T>>(value);

  useEffect(() => {
    if (
      !innerSelectedItem ||
      JSON.stringify(value) === JSON.stringify(innerSelectedItem)
    )
      return;

    onChange?.(innerSelectedItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [innerSelectedItem]);

  return (
    <VStack gap={0.75} className={new__cn(style.listItem, className)} {...rest}>
      {title && <div className={style.listItemTitle}>{title}</div>}

      <div role="radiogroup" className={style.itemListContainer}>
        {list.map(item => {
          const isSelected = innerSelectedItem?.id === item.id;

          return (
            <div
              aria-checked={isSelected}
              className={new__cn(style.itemContainer, itemClassName)}
              key={item.id}
              role="radio"
              onClick={() => {
                setInnerSelectedItem(item);
                onItemClick?.(item);
              }}
            >
              <div className={style.itemInfo}>
                <div className={style.itemName}>{item.name}</div>
                {item.len && <div className={style.itemNum}>{item.len}</div>}
              </div>

              {isSelected && <KeyboardArrowRight className={style.icon} />}
            </div>
          );
        })}
      </div>
    </VStack>
  );
};

VListItem.displayName = 'VListItem';

export default VListItem;
